import type { MetricStep, ResultType } from "../constants";

export const STEP_PATHS: Record<MetricStep, string> = {
  1: "/step-1",
  2: "/step-2",
  3: "/step-3",
};

export const OUTCOME_PATH = "/outcome";

export type EstimatorHistoryState =
  | { phase: "input"; step: MetricStep }
  | { phase: "result"; resultType: ResultType };

export function stepFromPath(pathname: string): MetricStep | null {
  if (pathname.endsWith("/step-3")) return 3;
  if (pathname.endsWith("/step-2")) return 2;
  if (pathname.endsWith("/step-1")) return 1;
  return null;
}

export function maxAccessibleStep(data: {
  sqFt?: number;
  propertyType?: string;
  zip?: string;
  city?: string;
}): MetricStep {
  if (data.zip && data.city) return 3;
  if (data.sqFt && data.propertyType) return 2;
  return 1;
}

export function pushEstimatorState(state: EstimatorHistoryState, path: string): void {
  history.pushState(state, "", path);
}

export function replaceEstimatorState(state: EstimatorHistoryState, path: string): void {
  history.replaceState(state, "", path);
}
